import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { Project } from 'src/content/Projects/types';

export interface ProjectState {
  projectData?: Project;
}

const initialState: ProjectState = {
  projectData: undefined
};

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setProjectData(state, action: PayloadAction<Project>) {
      state.projectData = action.payload;
    }
  }
});

export const { setProjectData } = projectSlice.actions;

export const reducer = projectSlice.reducer;
